import { ReactElement } from 'react';

import { ConfidentialResourceAccessRequest } from '@dreryk/egabinet-medical-data-confidentiality-frontend-api';

import { EmptyStatePlaceholder, Table } from '@dreryk/react-components';

import { systemActivityTranslationKeys } from '../translations';

import {
   useConfidentialResourceRequestsAccessTableColumnsConfiguration,
   useConfidentialResourceRequestsAccessTableDataConfiguration,
} from './ConfidentialResourceAccessRequestsTable.hooks';

export const ConfidentialResourceAccessRequestsTable = (): ReactElement => {
   const dataConfiguration = useConfidentialResourceRequestsAccessTableDataConfiguration();
   const columnsConfiguration = useConfidentialResourceRequestsAccessTableColumnsConfiguration();

   return (
      <Table<ConfidentialResourceAccessRequest>
         testId={'confidentialResourcesAccessRequests'}
         dataConfiguration={dataConfiguration}
         columns={columnsConfiguration}
         keyExtractor={'id'}
         placeholder={
            <EmptyStatePlaceholder
               testId={'noConfidentialResourcesAccessRequests'}
               heading={systemActivityTranslationKeys.noActivity}
               subheading={systemActivityTranslationKeys.thereWillBeVisitAccessHistory}
            />
         }
      />
   );
};
